export const STRUCTURE_API_VERSION = "2026-07-16";
